import { Controller } from "@hotwired/stimulus"
import { requestRefresh } from "../helpers/refresh_gate"

export default class extends Controller {
  connect() {
    this.disconnectedElements = new WeakSet()

    this.observer = new MutationObserver((mutations) => this.handleMutations(mutations))
    this.observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ["connected"],
    })
  }

  disconnect() {
    this.observer.disconnect()
  }

  handleMutations(mutations) {
    let shouldRefresh = false

    for (const { target } of mutations) {
      if (target.tagName !== "TURBO-CABLE-STREAM-SOURCE") continue

      const connected = target.hasAttribute("connected")

      if (connected && this.disconnectedElements.has(target)) shouldRefresh = true
      if (connected) {
        this.disconnectedElements.delete(target)
      } else {
        this.disconnectedElements.add(target)
      }
    }

    if (shouldRefresh) this.resync()
  }

  resync() {
    if (!document.querySelector("turbo-cable-stream-source")) return

    requestRefresh()
  }
}
